'use client';

import React from 'react';

interface ProgressTrackerProps {
  current: number;
  goal: number;
  contributors: number;
  label: string;
}

const ProgressTracker: React.FC<ProgressTrackerProps> = ({
  current,
  goal,
  contributors,
  label,
}) => {
  const percentage = Math.min((current / goal) * 100, 100);

  return (
    <div className="bg-card rounded-2xl shadow-sacred-md p-8 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-playfair text-xl lg:text-2xl font-semibold text-foreground">
          {label}
        </h3>
        <span className="font-inter text-sm text-muted-foreground">
          {contributors} {contributors === 1 ? 'contributor' : 'contributors'}
        </span>
      </div>

      <div className="space-y-4">
        <div className="flex items-baseline justify-between">
          <span className="font-playfair text-3xl lg:text-4xl font-bold text-primary">
            ${current.toLocaleString('en-US')}
          </span>
          <span className="font-inter text-sm text-muted-foreground">
            of ${goal.toLocaleString('en-US')} goal
          </span>
        </div>

        <div className="relative h-4 bg-surface rounded-full overflow-hidden">
          <div
            className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-1000 ease-out"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <div className="flex items-center justify-between pt-1">
          <span className="font-inter text-xs text-muted-foreground">
            {percentage.toFixed(1)}% funded
          </span>
          <span className="font-inter text-xs text-muted-foreground">
            ${(goal - current).toLocaleString('en-US')} remaining
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;